import { limit, or, query, where } from 'firebase/firestore'
import type { MedicineProduct } from '~/models'
import { ArrayService } from './serviceLive'

export class MedicineProductService extends ArrayService<MedicineProduct> {
  constructor() {
    super('MedicineProducts')
  }

  public listenForIdentifier(identifier: number): void {
    const listenQuery = query(
      this.collection,
      or(
        where('GPK', '==', identifier),
        where('HPK', '==', identifier),
        where('PRK', '==', identifier),
      ),
      limit(50),
    )
    this.listen(listenQuery)
  }

  public listenForBrand(brand: string): void {
    const words = brand.split(' ').map(word => word.toLowerCase())

    if (words[0] === '') {
      return
    }

    const listenQuery = query(
      this.collection,
      where('AllSearchTerms', 'array-contains', words[0]),
      limit(50),
    )
    this.listen(listenQuery)
  }
}
